import React, { useContext } from 'react';
import classNames from 'classnames';

import UiContext from 'common/UiContext/UiContext';

import fullLogo from './exapool-logo.png';
import fullLogoDark from './exapool-logo-dark.png';
import mark from './exapool-mark.png';

import './logo.scss';

type ILogo = {
  // 'full' shows the mark + "Exapool" wordmark; 'mark' shows just the truss glyph.
  variant?: 'full' | 'mark'
  className?: string
};

// Exapool brand artwork: an isometric truss hexagon with the "E" mark and a
// rising arrow. 'full' includes the wordmark; 'mark' is the glyph alone for
// compact spots (collapsed nav, etc.). The full wordmark has a dark-background
// rendition used on the dark theme; the transparent one is used on light.
const Logo = ({ variant = 'full', className }: ILogo) => {
  const { theme } = useContext(UiContext);
  const fullSrc = 'dark' === theme ? fullLogoDark : fullLogo;

  return (
    <span className={classNames('logo', `logo--${variant}`, className)}>
      <img
        className='logo-img'
        src={variant === 'full' ? fullSrc : mark}
        alt='Exapool'
      />
    </span>
  );
};

export default Logo;
